export const channels = {
  booking: 'Booking',
  expedia: 'Expedia',
  whatsapp: 'WhatsApp',
  personal_email: 'מייל אישי',
  diam_email: 'מייל DIAM',
  agoda: 'Agoda',
  airbnb: 'Airbnb'
};
export const statuses = {
  needs_reply: 'דורש מענה',
  awaiting_approval: 'ממתין לאישור',
  follow_up: 'במעקב / ממתין לביצוע',
  owner: 'בטיפול הבעלים',
  completed: 'הושלם',
  no_reply: 'אין צורך בתגובה'
};
export const colors = {
  needs_reply: 'error',
  awaiting_approval: 'warning',
  follow_up: 'info',
  owner: 'secondary',
  completed: 'success',
  no_reply: 'default'
};
export const samples = [['booking', 'נועה לוי', 'הגעה מאוחרת וצ׳ק אין', 'needs_reply', 'Airport', 'DEMO-1042', 'שלום, הטיסה שלי נוחתת ב־23:30. האם אפשר להגיע אחרי חצות?', 'לבדוק הנחיות הגעה ולנסח תשובה'], ['expedia', 'Daniel Cohen', 'בקשה לשינוי שעת יציאה', 'awaiting_approval', 'רוטשילד 79', 'DEMO-1043', 'Can we check out at 13:00 on Sunday?', 'להעביר לבעלים לאישור יציאה מאוחרת'], ['whatsapp', 'מיכל רז', 'עדכון לקראת ההגעה', 'follow_up', 'רוטשילד 79', 'DEMO-1044', 'תודה! נגיע בסביבות 16:00. נשמח להנחיות לפני ההגעה.', 'לוודא שהנחיות ההגעה הועברו'], ['diam_email', 'אורי ברק', 'שאלה על חניה באזור', 'owner', 'Airport', 'DEMO-1045', 'האם יש מקום חניה קרוב לבית ההארחה?', 'לבדוק את אפשרויות החניה עם הבעלים'], ['personal_email', 'Yael Shahar', 'תודה על האירוח', 'no_reply', 'רוטשילד 79', 'DEMO-1046', 'תודה רבה על האירוח, היה נעים מאוד.', '']].map((row, i) => ({
  _id: `demo-${i}`,
  channel: row[0],
  guestName: row[1],
  title: row[2],
  status: row[3],
  property: row[4],
  bookingReference: row[5],
  transcript: row[6],
  reason: row[3] === 'no_reply' ? 'הודעת תודה ללא שאלה פתוחה' : '',
  sourceUrl: '',
  version: 0,
  updatedAt: new Date(Date.now() - i * 3600000).toISOString()
}));

export const isHandled = item => ['completed', 'no_reply'].includes(item.status);
export function belongsToTab(item, tab) {
  if (tab === 'pending') return !isHandled(item);
  if (tab === 'automatic') return isHandled(item) && item.treatmentMode === 'automatic';
  return isHandled(item);
}
samples.forEach((item, i) => {
  item.checkIn = `2026-10-${String(5 + i).padStart(2, '0')}`;
  item.checkOut = `2026-10-${String(7 + i).padStart(2, '0')}`;
  item.treatmentMode = 'manual';
});
samples.push({
  _id: 'demo-automatic-review', channel: 'booking', guestName: 'Emma Rosen',
  title: 'הנחיות הגעה', status: 'completed', property: 'Airport', bookingReference: 'DEMO-1047',
  checkIn: '2026-10-08', checkOut: '2026-10-10', treatmentMode: 'automatic',
  transcript: 'Hi, how do I get to the guest house from the airport?',
  actionSummary: 'דוגמה: נענתה שאלה שגרתית על הגעה, ללא בקשת אישור.',
  responseText: 'Taxis are available at the airport taxi stand outside the terminal. The guest house is about 15 minutes from the airport.',
  reason: '', sourceUrl: '', version: 0, updatedAt: new Date().toISOString(),
});

samples.filter(x => !isHandled(x)).forEach(item => {
  const replies = {
    'demo-0': ['אפשר לתאם הגעה אחרי חצות. כתבו לנו את שעת ההגעה המשוערת ונבדוק עבורכם את פרטי הכניסה.', 'תודה על העדכון. נבדוק את אפשרות ההגעה המאוחרת ונחזור אליכם עם הנחיות.', 'קיבלנו את פרטי הטיסה. נבדוק כיצד לאפשר כניסה בשעת ההגעה שלכם ונעדכן אתכם.'],
    'demo-1': ['We will check whether a 13:00 checkout is possible and get back to you.', 'Thank you for asking. Late checkout depends on availability; we will confirm after checking.', 'A 13:00 departure may be possible. Please allow us to verify the schedule before we confirm.'],
    'demo-2': ['תודה על העדכון, נבדוק את פרטי ההגעה ונעביר לכם את ההנחיות.', 'קיבלנו את שעת ההגעה. נחזור אליכם עם פרטי הכניסה לפני ההגעה.', 'רשמנו שתגיעו בסביבות 16:00; נוודא שתקבלו את הנחיות הכניסה המתאימות.'],
    'demo-3': ['נבדוק את אפשרויות החניה באזור ונעדכן אותך.', 'תודה על השאלה. נחזור אליך עם מידע על חניה בקרבת המקום.', 'אין לנו עדיין פרט מאומת על חניה זמינה; נברר ונמסור לך מידע מדויק.'],
  };
  [item.suggestionFirst, item.suggestionSecond, item.suggestionThird] = replies[item._id] || ['', '', ''];
});

const englishDemo = samples.find(item => item._id === 'demo-1');
englishDemo.transcriptTranslation = 'האם נוכל לעשות צ׳ק אאוט ביום ראשון בשעה 13:00?';
englishDemo.suggestionFirstTranslation = 'נבדוק אם אפשר לעשות צ׳ק אאוט בשעה 13:00 ונחזור אליכם.';
englishDemo.suggestionSecondTranslation = 'תודה על השאלה. צ׳ק אאוט מאוחר תלוי בזמינות; נאשר לאחר בדיקה.';
englishDemo.suggestionThirdTranslation = 'ייתכן שתתאפשר יציאה בשעה 13:00. נא לאפשר לנו לבדוק את לוח הזמנים לפני שנאשר.';
const automaticDemo = samples.find(item => item._id === 'demo-automatic-review');
automaticDemo.transcriptTranslation = 'שלום, איך מגיעים לבית ההארחה משדה התעופה?';
automaticDemo.responseTranslation = 'מוניות זמינות בעמדת המוניות של שדה התעופה מחוץ לטרמינל. בית ההארחה נמצא במרחק של כ־15 דקות משדה התעופה.';
